import { Box, Text, TextProps } from 'grommet';
import { AnimationType } from 'grommet/utils';
import { CSSProperties, PropsWithChildren } from 'react';

export type TableHeaderItemProps = PropsWithChildren & {
  width?: string;
  animate?: boolean;
  animation?: AnimationType;
};

/** A table header's column label: small, grey and spaced, on the light header row */
export const tableHeaderTextProps: TextProps & { style: CSSProperties } = {
  size: 'xsmall',
  weight: 600,
  color: 'text-secondary',
  style: { letterSpacing: '0.04em' },
};

export const TableHeaderItem = ({
  width = '20%',
  animate = false,
  animation = { type: 'fadeIn', size: 'large' },
  children,
}: TableHeaderItemProps) => (
  <Box width={width} animation={animate ? animation : undefined}>
    <Text {...tableHeaderTextProps}>{children}</Text>
  </Box>
);
